import { json, redirect } from '@remix-run/node'
import { Form, useLoaderData } from '@remix-run/react'

import { login } from '../../shopify.server'

import styles from './styles.module.css'

export const loader = async ({ request }) => {
  const url = new URL(request.url)

  if (url.searchParams.get('shop')) {
    throw redirect(`/app?${url.searchParams.toString()}`)
  }

  return json({ showForm: Boolean(login) })
}

export default function App() {
  const { showForm } = useLoaderData()

  return (
    <div className={styles.index}>
      <div className={styles.content}>
        <div className={styles.banner}>
          <img src="/icon.png" />
          <h1 className={styles.heading}>Cyke Shopify App</h1>
        </div>
        <p className={styles.text}>
          Easily connect your Shopify Store to Cyke, and have your local deliveries made by bike.
        </p>
        {showForm && (
          <Form className={styles.form} method="post" action="/auth/login">
            <label className={styles.label}>
              <span>Shop domain</span>
              <input className={styles.input} type="text" name="shop" />
              <span>e.g: my-shop-domain.myshopify.com</span>
            </label>
            <button className={styles.button} type="submit">
              Log in
            </button>
          </Form>
        )}
      </div>
    </div>
  )
}
